module.exports = __webpack_public_path__ + "static/img/51.3a2a7769.png";